<section class="field-group" [formGroup]="frmZipLookup">
  <div class="field-holder" *ngIf="frmZipLookup.getRawValue()?.zipCode !== 'UtilityStateSelected'">
    <mat-form-field appearance="standard">
      <mat-label>Zip Code</mat-label>
      <input id="zipCode" matInput type="text" formControlName="zipCode" />
      <mat-error *ngIf="frmZipLookup.get('zipCode')?.errors?.required"> Please enter a Zip Code </mat-error>
      <mat-error *ngIf="frmZipLookup.get('zipCode')?.errors?.invalidZip"> Invalid Zip Code. Please try again </mat-error>
      <mat-error *ngIf="frmZipLookup.get('zipCode')?.errors?.serviceErr"> Sorry, the zip code lookup service is not available </mat-error>
      <mat-error *ngIf="frmZipLookup.get('zipCode')?.errors?.minlength"> Minimum length is 5 characters </mat-error>
      <mat-error *ngIf="frmZipLookup.get('zipCode')?.errors?.maxlength"> Maximum length is 7 characters </mat-error>
      <mat-spinner matSuffix [diameter]="16" *ngIf="working" color="accent" [matTooltip]="'Searching Zipcode..'"></mat-spinner>
    </mat-form-field>
  </div>

  <div class="field-holder" *ngIf="frmZipLookup.getRawValue()?.city && frmZipLookup.getRawValue()?.city !== 'UtilityStateSelected'">
    <mat-form-field appearance="standard">
      <mat-label>City</mat-label>
      <input formControlName="city" matInput type="text" readonly />
    </mat-form-field>
  </div>

  <div class="field-holder" *ngIf="frmZipLookup.getRawValue()?.state">
    <mat-form-field appearance="standard">
      <mat-label>State</mat-label>
      <input formControlName="state" matInput type="text" readonly />
    </mat-form-field>
  </div>
</section>
